import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { take, map, switchMap } from "rxjs/operators";
import { UserFacadeService } from "../../facades/userfacade/userfacade.service";
import { TranslatorService } from "../../translator/translator.service";
import { User } from "../../_models/user";
import { InitialOnboardingStatus } from "src/app/routes/onboarding/models";
import { UnleashService } from "../../api_services/unleash.service";

@Injectable({
  providedIn: "root",
})
export class UserResolverService {
  constructor(
    private userFacadeService: UserFacadeService,
    private translator: TranslatorService,
    private router: Router,
    private unleash: UnleashService,
  ) {}

  resolve() {
    return this.userFacadeService.getOrganisationUser().pipe(
      switchMap((user: User) => {
        if (user.language != null) {
          this.translator.useLanguage(user.language);
        }
        return this.userFacadeService.getOrganisationInfo().pipe(
          map((organization) => {
            this.userFacadeService.organizationInformation.next(organization);
            this.userFacadeService.organizationId.next(organization._id);
            if (organization.language != null && user.language == null) {
              this.translator.useLanguage(organization.language);
            }
            this.userFacadeService.userMapper(user, organization).toPromise();

            const firstLogin = user.permissions.find((c) => c.value === "FirstLogin");
            if (firstLogin) {
              this.router.navigate(["/resetpassword"]);
            }

            const onboardingNeeded =
              organization?.initialOnboarding.status ==
                InitialOnboardingStatus.NotStarted ||
              organization?.initialOnboarding.status ==
                InitialOnboardingStatus.InProgress;
            const targetUrl =
              this.router.getCurrentNavigation()?.finalUrl?.toString() ?? this.router.url;
            const isNavigatingToOnboarding = targetUrl.startsWith("/onboarding");
            if (
              onboardingNeeded &&
              !isNavigatingToOnboarding &&
              this.unleash.isEnabled("portal.onBoarding-after.registeration")
            ) {
              if (
                organization?.initialOnboarding.status ==
                InitialOnboardingStatus.NotStarted
              )
                this.router.navigate(["/onboarding/welcome"]);
              else this.router.navigate(["/onboarding/setup"]);
            }

            return this.userFacadeService.user.pipe(map((u) => u));
          }),
        );
      }),
      take(1),
    );
  }
}
